import {BreadcrumbType} from 'platform/components';

import {useGetRoleQuery} from '@dms/api/security';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {useRequiredParams} from 'shared/web';

import {RoleDetail} from './RoleDetail';

export function RoleEdit() {
  const {roleId} = useRequiredParams();
  const {data: role, isLoading, isError} = useGetRoleQuery({roleId});

  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('page.settings.labels.roleManagement'),
      href: settingsRoutes.roleManagement,
    },
  ];

  return (
    <SettingsTemplate
      header={{breadcrumbs, title: role?.title}}
      data-testid="settings-management-role-layout"
      isLoading={isLoading}
      isError={isError}
    >
      <RoleDetail />
    </SettingsTemplate>
  );
}
